
export default {
    computed: {
        //启用状态
        getActives() {
            return [
                {
                    value: null,
                    label: this.$t('global.common.all', { defaultValue: '全部' }),
                },
                {
                    value: '1',
                    label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                },
                {
                    value: '0',
                    label: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用' }),
                },
            ]
        },
    },
}